import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, Validator } from '@angular/forms';
import { AuthenticationService } from '../services/authentication.service';
import { ErrorService } from '../services/error.service';

@Directive({
	selector: '[appCaptchaValidator]',
	providers: [
		{
			provide: NG_ASYNC_VALIDATORS,
			useExisting: forwardRef(() => CaptchaValidatorDirective),
			multi: true
		}
	]
})
export class CaptchaValidatorDirective implements Validator {

	constructor(private _authenticationService: AuthenticationService,
				private _errorService: ErrorService) {
	}

	validate(c: AbstractControl): Promise<{ [key: string]: any }> {
		return new Promise(resolve => {
			if (c.value == null) {
				resolve({invalidToken: true});
			} else {
				this._authenticationService.captchaVerification(c.value).subscribe((response) => {
					if (response) {
						resolve(null);
					} else {
						resolve({invalidToken: true});
					}
				}, (error) => {
					this._errorService.error(error, 'Unable to verify captcha!', 'modal');
					resolve({invalidToken: true});
				});
			}
		});
	}

}
